import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {EmSelectModule} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';
import {EmOperandIconModule} from '../operand-icon/operand-icon.module';
import {EmOperandWithIconModule} from '../operand-with-icon/operand-with-icon.module';
import {EmSelectOperandComponent} from './select-operand.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    EmSelectModule,
    EmOperandWithIconModule,
    EmOperandIconModule,
    EmSelectModule,
  ],
  declarations: [EmSelectOperandComponent],
  exports: [EmSelectOperandComponent],
})
export class EmSelectOperandModule {}
